import {AccountDTO, UserProfile, UserRecordDTO} from "../../types";
import * as action_types from '../actions/actionTypes';

export type EmployeeState = {
    loading_employee_data: boolean;
    association_account: AccountDTO | null;
    employee_is_managing: boolean;
    employee_manage_user: UserProfile | null;
};

const initial_state: EmployeeState = {
    loading_employee_data: true,
    association_account: null,
    employee_is_managing: false,
    employee_manage_user: null
};

const set_loading_employee_data = (state: EmployeeState, action: any): EmployeeState => {
    return {
        ...state,
        loading_employee_data: action.loading_employee_data
    }
};

const set_association_account = (state: EmployeeState, action: any): EmployeeState => ({
    ...state,
    association_account: action.association_account
});

const set_employee_is_managing = (state: EmployeeState, action: any): EmployeeState => ({
    ...state,
    employee_is_managing: action.employee_is_managing
});

const set_employee_manage_user = (state: EmployeeState, action: any): EmployeeState => ({
    ...state,
    employee_manage_user: action.manage_user
});

const reducer = (state = initial_state, action: any) => {
    switch (action.type) {
        case action_types.EMPLOYEE_SET_LOADING_EMPLOYEE_DATA:
            return set_loading_employee_data(state, action);
        case action_types.EMPLOYEE_SET_ASSOCIATION_ACCOUNT:
            return set_association_account(state, action);
        case action_types.EMPLOYEE_SET_IS_MANAGING:
            return set_employee_is_managing(state, action);
        case action_types.EMPLOYEE_SET_MANAGE_USER:
            return set_employee_manage_user(state, action);
        default:
            return state;
    }
};

export default reducer;